import { render } from "./FormulaSettings.vue?vue&type=template&id=648a2567&scoped=true&ts=true"
import script from "./FormulaSettings.vue?vue&type=script&lang=ts"
export * from "./FormulaSettings.vue?vue&type=script&lang=ts"

import "./FormulaSettings.vue?vue&type=style&index=0&id=648a2567&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a2567"]])

export default __exports__